import type { LlmProvider } from "@/features/llm-usage/api/llm-usage.api";
import type { EventTimeRange } from "@/features/events/constants/event-time-ranges";

/** What the Token Usage tab is scoped to. Owned by the route's search params. */
export interface LlmUsageFiltersState {
  range: EventTimeRange;
  /** One of `LLM_USAGE_FEATURES`, or undefined for every surface. */
  feature: string | undefined;
  /** A tenant id, or undefined for every tenant. */
  tenantId: string | undefined;
  /** A single vendor, or undefined for both. */
  provider: LlmProvider | undefined;
}

/** Every scope dropped, leaving only the window the page is read over. */
export function clearLlmUsageScopes(filters: LlmUsageFiltersState): LlmUsageFiltersState {
  return { range: filters.range, feature: undefined, tenantId: undefined, provider: undefined };
}

export function hasLlmUsageScope(filters: LlmUsageFiltersState): boolean {
  return filters.provider != null || filters.feature != null || filters.tenantId != null;
}
